import React from 'react';
import { IconBrandMysql } from '@tabler/icons';

import ProgressBar from "@ramonak/react-progress-bar";

const Backend = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Backend Developer</h3>
      
        <div className="skills__box">
        
          <div className="skills__group">
              <div className="skills__data">
              <i class='bx bxl-nodejs'></i>
              {/* <i className="fa-brands fa-node"></i> */}
              {/* <IconBrandNodejs /> */}
              {/* <i class="fa-brands fa-node"></i> */}
              {/* <FontAwesomeIcon icon="fa-brands fa-node" /> */}
              <div>
                <h3 className="skills__name">NodeJS</h3>
                {/* <span className="skills__level">Advanced</span>
                */}
              <ProgressBar 
                  completedClassName="barCompleted"
                  labelClassName="label"
                  className="skills__level"
                  completed={80} 
              />
              </div>
              
              </div>
              
              <div className="skills__data">
              {/* <i className="bx bx-badge-check"></i> */}
              <IconBrandMysql />
              <div>
                <h3 className="skills__name">MySql</h3>
                {/* <span className="skills__level">Master</span> */}
              <ProgressBar 
                  completedClassName="barCompleted"
                  labelClassName="label"
                  className="skills__level"
                  completed={100} 
              />
              </div>
              
              </div>
              
              <div className="skills__data">
              <i className="bx bxl-mongodb"></i>
              {/* <IconBrandMongodb /> */}
              <div>
                <h3 className="skills__name">MongoDB</h3>
                {/* <span className="skills__level">Advanced</span> */}
              <ProgressBar 
                  completedClassName="barCompleted"
                  labelClassName="label"
                  className="skills__level"
                  completed={90} 
              />
              </div>
              
              </div>
              
              <div className="skills__data">
                <i className="bx bxl-php"></i>
              <div>
                <h3 className="skills__name">PHP</h3>
                  <ProgressBar 
                    completedClassName="barCompleted"
                    labelClassName="label"
                    className="skills__level"
                    completed={90} 
                  />
                {/* <span className="skills__level">Intermediate</span> */}
              </div>
              
              </div>
          </div> 
          
          
          <div className="skills__group">
              <div className="skills__data">
              {/* <i className="bx bxl-postgresql"></i> */}
              {/* <IconBrandPostgresql /> */}
              <i class='bx bxl-postgresql' ></i>
              <div>
                <h3 className="skills__name">PostgreSql</h3>
                                  <ProgressBar 
                    completedClassName="barCompleted"
                    labelClassName="label"
                    className="skills__level"
                    completed={70} 
                  />
                {/* <span className="skills__level">Intermediate</span> */}
              </div>
              
              </div>
              
            <div className="skills__data">
              <i className="bx bxl-firebase"></i>
              
              <div>
                <h3 className="skills__name">Firebase</h3>
                <ProgressBar 
                    completedClassName="barCompleted"
                    labelClassName="label"
                    className="skills__level"
                    completed={75} 
                  />
                {/* <span className="skills__level">Advanced</span> */}
              </div>
              
              </div>
              
            <div className="skills__data">
              <i className="bx bxl-aws"></i>
              
              <div>
                <h3 className="skills__name">AWS</h3>
                <ProgressBar 
                    completedClassName="barCompleted"
                    labelClassName="label"
                    className="skills__level"
                    completed={90} 
                  />
                {/* <span className="skills__level">Masteral</span> */}
              </div>
              
              </div>
              
            <div className="skills__data">
              <i className="bx bxl-django"></i>
              
              <div>
                <h3 className="skills__name">Django</h3>
                <ProgressBar 
                    completedClassName="barCompleted"
                    labelClassName="label"
                    className="skills__level"
                    completed={65} 
                  />
                {/* <span className="skills__level">Advanced</span> */}
              </div>
              
              </div>
          </div> 
        </div>
    </div>
  )
}

export default Backend;
